import * as React from 'react';
import { NextPage } from 'next';
import { Events } from '../src/components/Event';
import { Layout } from '../src/components/Layout';
import useEvents from '@/modules/data/types/hooks/useEvents';
import { ErrorPage } from '@/components/Error';
import { Spinner } from '@/components/Spinner';
import {
	serverDomain,
	axiosConfig,
	isEventInFuture,
	isEventPublic,
} from '@/lib/index';
import Sentry from '@/modules/sentry/init';
import axios from 'axios';
import { EventProps } from '@/modules/data/types';
import { createLogger } from '@/modules/logging/logger';

let logger = createLogger({
	fileLabel: '/pages/events',
});

interface EventsProps {
	eventsData: EventProps[];
}
// export async function getStaticProps() {
// 	try {
// 		const res = await axios.get(`${serverDomain}/api/events/`, axiosConfig);
// 		const eventsData = res.data;
// 		return {
// 			props: {
// 				eventsData,
// 			},
// 		};
// 	} catch (e) {
// 		logger.error(e);
// 		Sentry.captureException(e);
// 	}
// }

const Page: NextPage<EventsProps> = ({ eventsData }) => {
	const { events, isLoading, isError } = useEvents(eventsData);

	if (isError) return <ErrorPage />;
	if (isLoading) return <Spinner />;

	const site = {
		title: `Events`,
		header: 'TBA',
		// description: 'Discover lit events.',
	};
	return (
		<Layout data={site}>
			<Events events={events} />
		</Layout>
	);
};

export default Page;
